module.exports = __webpack_public_path__ + "img/weekly-deliveries-selected.58f282bd.png";